var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusTrackingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.791,
    height: 47.792,
    viewBox: "0 0 47.791 47.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2312",
    "data-name": "Group 2312",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M19.875,3.068l-9.081,9.081A11.054,11.054,0,0,1,12.9,17.3a2.351,2.351,0,0,1,.551-.089H25.414a2.35,2.35,0,0,1,.321.052,23.8,23.8,0,0,0-5.86-14.2Z",
    transform: "translate(22.556 5.628)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M.5,24.435A23.926,23.926,0,0,0,22.891,48.292a2.37,2.37,0,0,1-.052-.321V36a2.371,2.371,0,0,1,.089-.551A11.14,11.14,0,1,1,31.093,15.52l9.081-9.081A23.906,23.906,0,0,0,.5,24.435Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M30.5,8.561H18.533a2.351,2.351,0,0,1-.551-.089,11.122,11.122,0,0,1-9.51,9.51,2.371,2.371,0,0,1,.088.551V30.5a2.369,2.369,0,0,1-.052.321A23.909,23.909,0,0,0,30.821,8.509a2.349,2.349,0,0,1-.321.052Z",
    transform: "translate(17.47 17.47)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusTrackingIcon);
export default __webpack_public_path__ + "static/media/StatusTracking_icon.a4524160850ebbd183acaeffff06d9c2.svg";
export { ForwardRef as ReactComponent };